import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";

let hover = false;
function BootstrapSlider(props) {
  const [hovering, update] = useState(false);

  return (
    <Carousel>
      {props.slides.map((singleSlide, index) => (
        <Carousel.Item key={index}>
          <img
            className="d-block w-100"
            src={singleSlide.url}
            alt="First slide"
          />
          <div
            className="tips"
            onMouseOver={() => {
              hover = true;
              setTimeout(() => {
                if (hover) {
                  props.handleHover(true, singleSlide.tip);
                }
              }, 100);
            }}
            onMouseOut={() => {
              hover = false;
              props.handleHover(false, undefined);
            }}
          ></div>
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default BootstrapSlider;
